import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { SourceInfo, SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RegExpUtility } from "../../text/RegExpUtility";
import { Arrays } from "../../tools/Arrays";
import { isClassOf } from "../../tools/TypeUtilities";
import { RJParser } from "../RJParser";
import { CustomExpressionFactory } from "./CustomExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";
import { RJToken } from "./RJToken";


export abstract class RJExpressionNode
{
  _parent:RJExpressionNode;
  get parent(){ return this._parent; }

  _setParent( parent: RJExpressionNode )
  {
    this._parent = parent;
  }

  _parser:RJParser;
  get parser(){ return this._parser; }

  _type:RJExpressionNodeType;
  get type(){ return this._type; }
  

  get typeString(){ return RJExpressionNodeType[ this._type ] };

  protected _sourceRange:SourceRange;
  get sourceRange():SourceRange
  {
    return this._sourceRange;
  };

  get sourceInfo():SourceInfo
  {
    let info = new SourceInfo();
    info.range = this._sourceRange;
    return info;
  };

  protected _children:RJExpressionNode[] = [];

  constructor( parser:RJParser, type:RJExpressionNodeType, range:SourceRange )
  {
    this._parser = parser;
    this._type = type;
    this._sourceRange = range;
  }

  writeDebugInfo( output:string[], level:number = 0)
  {    
    let ownOutput = RegExpUtility.repeat( "  ", level ) + `[${this.typeString}]`;
    output.push( ownOutput );

    for ( let i = 0; i < this._children.length; i++ )
    {
      this._children[ i ].writeDebugInfo( output, level + 1 );
    }
  }

  getDebugInfo()
  {
    let output:string[] = [];
    
    this.writeDebugInfo( output );

    return output.join( "\n" );
  }

  static toDebugInfo( nodes:RJExpressionNode[] )
  {
    let output:string[] = [];

    for ( let i = 0; i < nodes.length; i++ )
    {
      nodes[ i ].writeDebugInfo( output );
    }

    return output.join( "\n" );
  }

  abstract cloneNode():RJExpressionNode

  abstract createHTMLElement():Element;

  static readonly sourceRangeAttribute = new ElementAttribute( "source-range" );

  _createRawHTMLElement():Element
  {
    let element = new ElementType( "rj-" + RJExpressionNodeType[ this._type ] ).create(); 

    let sourceRangeValue = this.sourceRange.offset + " - " + ( this.sourceRange.length + this.sourceRange.offset );
    RJExpressionNode.sourceRangeAttribute.to( element, sourceRangeValue );
    return element;
  }

  protected _copyExpressionNodeData( target:RJExpressionNode )
  {
    target._parser = this._parser;
    target._type  =  this._type;
    target._sourceRange = this._sourceRange;

    this._children.forEach(
      ( c )=>
      {
        target._children.push( c.cloneNode() );
      }
    );

  }

  isToken( typeMatcher:string|RegExp, valueMatcher:string|RegExp = null ):boolean
  {
    let token  = this as any as RJToken;

    if ( ! token._lexerEvent )
    {
      return false;
    }
    
    var valueMatches = RegExpUtility.matches( token.match, valueMatcher );
    var typeMatches  = RegExpUtility.matches( token.tokenType, typeMatcher );

    return valueMatches && typeMatches;     
  }

  static replaceRange( elements:RJExpressionNode[] , startIndex:number, numElements:number, replacement:RJExpressionNode ):RJExpressionNode[] 
  {   
    return elements.splice( startIndex, numElements, replacement );
  }

  
  static split( elements:RJExpressionNode[], typeMatcher:string|RegExp, valueMatcher:string|RegExp = null, factory:CustomExpressionFactory )
  {
    let splitElements:number[] = [];

    for ( let i = 0; i < elements.length; i++ )
    {
      
    }
  }
  

}

